<template>
    <button v-on:click="dark_modeChange">
        <span v-if="!dark_mode" class="material-symbols-outlined text-enriqueto_green">
        dark_mode
        </span>
        <span v-if="dark_mode" class="material-symbols-outlined text-enriqueto_green">
        light_mode
        </span>
    </button>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { Inertia } from '@inertiajs/inertia'

export default {
    setup(){
        const store = useStore()

        const dark_mode = computed(() => store.state.dark_mode);

        const dark_modeChange = () => {
            let dmode = !dark_mode.value
            console.log(dmode)
            store.commit('changeColorMode',dmode)
            Inertia.reload()
        }
        return{
            dark_modeChange,
            dark_mode
        }
    }
}
</script>

<style>

</style>